import { createContext } from 'react';

import { ICorSelect } from '../../../modules/types/Cor';

export interface ColorContextType {
  coresSelect: ICorSelect[];
  loading: boolean;
}

export const ColorContext = createContext<ColorContextType>({
  coresSelect: [],
  loading: false,
});
